const {
    NEXT_PUBLIC_ROKT_MPARTICLE_API_KEY: ROKT_API_KEY,
    NEXT_PUBLIC_ROKT_DOMAIN: ROKT_DOMAIN,
    NEXT_PUBLIC_ROKT_DEVELOPMENT_MODE,
  } = process.env;
  
// Rokt is currently enabled only for internal testing through the `rokt=true`
// header/query parameter. Production enablement will be controlled by Target decisioning.
const ROKT_DEVELOPMENT_MODE = NEXT_PUBLIC_ROKT_DEVELOPMENT_MODE === 'true';

export const IS_ROKT_CONFIGURED = Boolean(
    ROKT_API_KEY && ROKT_DOMAIN,
);

export { ROKT_DOMAIN };

// Returns the Rokt/mParticle bootstrap code. The SDK is injected only when
// `enableRokt` is true.
export function getRoktInitScript(): string {
    return `
        const API_KEY = ${JSON.stringify(ROKT_API_KEY)};
        const ROKT_DOMAIN = ${JSON.stringify(ROKT_DOMAIN)};

        window.mParticle = {
        config: {
            isDevelopmentMode: ${ROKT_DEVELOPMENT_MODE},
        },
        };

        (function(e) {
        window.mParticle = window.mParticle || {};
        window.mParticle.EventType = {
            Unknown: 0,
            Navigation: 1,
            Location: 2,
            Search: 3,
            Transaction: 4,
            UserContent: 5,
            UserPreference: 6,
            Social: 7,
            Other: 8,
            Media: 9,
        };

        window.mParticle.eCommerce = { Cart: {} };
        window.mParticle.Identity = {};
        window.mParticle.Rokt = {};
        window.mParticle.config = window.mParticle.config || {};
        window.mParticle.config.rq = [];
        window.mParticle.config.snippetVersion = 2.8;

        window.mParticle.ready = function(cb) {
            window.mParticle.config.rq.push(cb);
        };

        [
            "endSession",
            "logError",
            "logBaseEvent",
            "logEvent",
            "logForm",
            "logLink",
            "logPageView",
            "setSessionAttribute",
            "setAppName",
            "setAppVersion",
            "setOptOut",
            "setPosition",
            "startNewSession",
            "startTrackingLocation",
            "stopTrackingLocation",
        ].forEach(function(method) {
            window.mParticle[method] = function() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            window.mParticle.config.rq.push(args);
            };
        });

        [
            "setCurrencyCode",
            "logCheckout",
        ].forEach(function(method) {
            window.mParticle.eCommerce[method] = function() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift("eCommerce." + method);
            window.mParticle.config.rq.push(args);
            };
        });

        [
            "identify",
            "login",
            "logout",
            "modify",
        ].forEach(function(method) {
            window.mParticle.Identity[method] = function() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift("Identity." + method);
            window.mParticle.config.rq.push(args);
            };
        });

        [
            "selectPlacements",
            "hashAttributes",
            "hashSha256",
            "setExtensionData",
            "use",
            "getVersion",
            "terminate",
            "onShoppableAdsReady",
        ].forEach(function(method) {
            window.mParticle.Rokt[method] = function() {
            var args = Array.prototype.slice.call(arguments);
            args.unshift("Rokt." + method);
            window.mParticle.config.rq.push(args);
            };
        });

        var env = window.mParticle.config.isDevelopmentMode ? 1 : 0;
        var query = "?env=" + env;
        var dataPlan = window.mParticle.config.dataPlan;

        if (dataPlan) {
            var planId = dataPlan.planId;
            var planVersion = dataPlan.planVersion;

            if (planId) {
            if (planVersion && (planVersion < 1 || planVersion > 1000)) {
                planVersion = null;
            }

            query +=
                "&plan_id=" +
                planId +
                (planVersion ? "&plan_version=" + planVersion : "");
            }
        }

        var versions = window.mParticle.config.versions;
        var versionParams = [];

        versions &&
            Object.keys(versions).forEach(function(key) {
            versionParams.push(key + "=" + versions[key]);
            });

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;

        window.ROKT_DOMAIN =
            ROKT_DOMAIN || "https://apps.rokt-api.com";

        mParticle.config.domain =
            window.ROKT_DOMAIN.split("//")[1];

        script.src =
            window.ROKT_DOMAIN +
            "/js/v2/" +
            e +
            "/app.js" +
            query +
            "&" +
            versionParams.join("&");

        script.onerror = function() {
            var fallbackDomain =
            "https://apps.roktecommerce.com";

            window.ROKT_DOMAIN = fallbackDomain;
            mParticle.config.domain =
            fallbackDomain.split("//")[1];

            var fallbackScript =
            document.createElement("script");

            fallbackScript.type = "text/javascript";
            fallbackScript.async = true;

            fallbackScript.src =
            fallbackDomain +
            "/js/v2/" +
            e +
            "/app.js" +
            query +
            "&" +
            versionParams.join("&");

            var firstScript =
            document.getElementsByTagName("script")[0];

            firstScript.parentNode.insertBefore(
            fallbackScript,
            firstScript,
            );
        };

        var firstScript =
            document.getElementsByTagName("script")[0];

        firstScript.parentNode.insertBefore(
            script,
            firstScript,
        );
        })(API_KEY);
    `;
}